import { render, staticRenderFns } from "./TableInspection.vue?vue&type=template&id=54021f6c&scoped=true"
import script from "./TableInspection.vue?vue&type=script&lang=js"
export * from "./TableInspection.vue?vue&type=script&lang=js"
import style0 from "./TableInspection.vue?vue&type=style&index=0&id=54021f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54021f6c",
  null
  
)

export default component.exports